import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";

import { DIALOG_TYPES } from "./AccountEditorConsts";
import AccountEditorFields from "./AccountEditorFields";
import ConfirmationDialog from "./ConfirmationDialog";
import useAccountEditorController from "./useAccountEditorController";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const AccountEditorDialog = ({
  open,
  title,
  onClose,
  onConfirm,
  onResetError,
  accountData,
  type,
  error,
  errorText
}) => {
  const {
    newAccountData,
    dialogContent,
    isConfirmationDialogOpen,
    isLoading,
    isSaveDisabled,
    handleTextFieldChange,
    handleSaveButtonClicked,
    handleSubmit,
    handleConfirmationClose
  } = useAccountEditorController({
    accountData,
    type,
    error,
    errorText,
    onConfirm,
    onResetError
  });

  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        title={title}
        onClose={onClose}
      >
        <DialogTitle>{dialogContent?.title}</DialogTitle>

        <DialogContent>
          <Typography
            style={{ whiteSpace: "pre-line" }}
            variant="body1"
            color="text.800"
          >
            {dialogContent?.subtitle}
          </Typography>
          {type !== DIALOG_TYPES.delete && !error
            ? (
              <AccountEditorFields
                type={type}
                data={newAccountData}
                onChange={handleTextFieldChange}
              />
            )
            : null}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <HyroButton variant={BUTTON_VARIANTS.TEXT} color={BUTTON_COLORS.SECONDARY} data-testid='cancel-create-account-button' onClick={onClose}>Cancel</HyroButton>
          <HyroButton
            data-testid='create-account-button'
            loading={!error && isLoading && !isConfirmationDialogOpen}
            onClick={handleSaveButtonClicked}
            variant={BUTTON_VARIANTS.CONTAINED}
            color={BUTTON_COLORS.PRIMARY}
            disabled={!error && isSaveDisabled}
          >
            {dialogContent.actionButtonText}
          </HyroButton>
        </DialogActions>
      </Dialog >
      {
        isConfirmationDialogOpen
          ? (
            <ConfirmationDialog
              open={isConfirmationDialogOpen}
              isSaveDisabled={isSaveDisabled}
              onClose={handleConfirmationClose}
              onDiscard={onClose}
              onSubmit={handleSubmit}
              isLoading={isLoading}
              accountName={accountData.name.value}
            />
          )
          : null}
    </>
  );
};

export default AccountEditorDialog;
